
import axios from 'axios';

const searchStringUtil = async (token, searchBy, string, dateFilter, startDate, endDate) => {

    let resData;
    var data = {
      "token": token,
      "string": string,
      "dateFilter": dateFilter,
      "startDate": startDate,
      "endDate": endDate
    };

    console.log('searchString data sent to server: ' + JSON.stringify(data))
    
    const headers = { 
        'Content-Type': 'application/json'
    };

    // console.log(data);
    try {
        resData = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/search-by-'+searchBy, data, { headers })
        
    }catch(err) {
        console.log('searchString: error received from Axios',err.message);
        throw new Error(err.message); 
    }
    console.log('searchString results', JSON.stringify(resData))

    return resData;
    
};

export default searchStringUtil